import { BaseFormula } from "../BaseFormula";
import { CalculationResult } from "../CalculationResult";
import { ChangeType } from "../ChangeType";
import { CostData } from "../CostData";

export class Formula_TrendDeviation extends BaseFormula
{
    evaluate(data: CostData[], value: CostData, change: ChangeType, parameters: { threshold: number }, show_new_cost: boolean): CalculationResult
    {
        let err = this.checkLength(data, 3, show_new_cost);
        if (err)
            return err;

        let x = Array.from({ length: data.length }, (_, i) => i);
        let y = data;

        let length = x.length;
        let sum_of_x = x.reduce((a, b) => a + b, 0);
        let sum_of_y = y.reduce((a, b) => a + b.amount, 0);
        let sum_of_xy = x.reduce((a, b, i) => a + b * y[i].amount, 0);
        let sum_of_x2 = x.reduce((a, b) => a + b * b, 0);

        let slope = (length * sum_of_xy - sum_of_x * sum_of_y) / (length * sum_of_x2 - sum_of_x * sum_of_x);
        let intercept = (sum_of_y - slope * sum_of_x) / length;

        let predicted_value = slope * (data.length - 1) + intercept;

        if (Math.abs(predicted_value) < 1e-10)
            return {
                value: null,
                reason: `Predicted Value is too small.`,
                values: { length, sum_of_x, sum_of_y, sum_of_xy, sum_of_x2, slope, intercept, predicted_value }
            };

        let deviation = (value.amount - predicted_value) / Math.abs(predicted_value);

        err = this.checkChnage(change, deviation, { length, sum_of_x, sum_of_y, sum_of_xy, sum_of_x2, slope, intercept, predicted_value, deviation });
        if (err)
            return err;

        return {
            value: Math.abs(deviation) > parameters.threshold,
            values: { length, sum_of_x, sum_of_y, sum_of_xy, sum_of_x2, slope, intercept, predicted_value, deviation }
        };
    }
} 